import { render, staticRenderFns } from "./authenticate.vue?vue&type=template&id=61cb8ff4&scoped=true&"
import script from "./authenticate.vue?vue&type=script&lang=ts&"
export * from "./authenticate.vue?vue&type=script&lang=ts&"
import style0 from "./authenticate.vue?vue&type=style&index=0&id=61cb8ff4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cb8ff4",
  null
  
)

export default component.exports